var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import { isInvalid, submit as _submit, destroy as _destroy2 } from 'redux-form';
import { objMap } from './utils';
import form from './form';
/**
 * Generate a redux wizard form from a schema.
 * @param {object} UIKit - A map of field types to react components.
 * @param {string} formName - The name of the form.
 * @param {object} schema  - The schema to use.
 * @param {object} reduxFormOptions - Optional options object for `redux-form`.
 * @returns {object} - The form react element.
 */

export default function wizardForm(UIKit, formName, schema, reduxFormOptions) {
  var pages = objMap(schema, function (pageSchema) {
    return form(UIKit, formName, pageSchema, _extends({}, reduxFormOptions, {
      destroyOnUnmount: false,
      forceUnregisterOnUnmount: true
    }));
  });
  var lastPageIndex = pages.length - 1;

  var WizardForm = function (_PureComponent) {
    _inherits(WizardForm, _PureComponent);

    function WizardForm(props) {
      _classCallCheck(this, WizardForm);

      var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

      _this.state = {
        page: 0
      };

      _this.previousPage = function () {
        var page = _this.state.page;
        var nextPage = page > 0 ? page - 1 : page;

        _this.setState({
          page: nextPage
        }, _this.onPageChange);
      };

      _this.onPageChange = function (formData) {
        var onPageChange = _this.props.onPageChange;
        var page = _this.state.page;
        if (onPageChange) onPageChange({
          currentPage: page,
          hasPrevPage: page !== 0,
          hasNextPage: page !== pages.length - 1,
          totalPages: pages.length
        }, formData);
      };

      _this.handleSubmit = function (formData) {
        var page = _this.state.page;
        if (page !== lastPageIndex) return _this.nextPage();
        var onSubmit = _this.props.onSubmit;
        onSubmit(formData);
      };

      var backHandlerRef = _this.props.backHandlerRef;
      if (backHandlerRef) backHandlerRef(_this.previousPage);

      _this.onPageChange();

      return _this;
    }

    WizardForm.prototype.componentWillUnmount = function componentWillUnmount() {
      var destroy = this.props.destroy;
      destroy();
    };

    WizardForm.prototype.nextPage = function nextPage(formData) {
      var _this2 = this;

      var page = this.state.page;
      var nextPage = page < lastPageIndex ? page + 1 : page;
      this.setState({
        page: nextPage
      }, function () {
        return _this2.onPageChange(formData);
      });
    };

    WizardForm.prototype.render = function render() {
      var _props = this.props,
          _onSubmit = _props.onSubmit,
          _destroy = _props.destroy,
          _backHandlerRef = _props.backHandlerRef,
          _onPageChange = _props.onPageChange,
          transitionName = _props.transitionName,
          className = _props.className,
          disabled = _props.disabled,
          rest = _objectWithoutProperties(_props, ['onSubmit', 'destroy', 'backHandlerRef', 'onPageChange', 'transitionName', 'className', 'disabled']);

      var page = this.state.page;
      var key = page;
      var Form = pages[key].Form;
      return React.createElement('div', {
        className: className
      }, React.createElement(ReactCSSTransitionGroup, {
        transitionName: transitionName,
        transitionEnterTimeout: 800,
        transitionLeave: false
      }, React.createElement('div', {
        key: key,
        style: {
          position: 'relative'
        }
      }, React.createElement(Form, _extends({
        className: className && className + '-form',
        disabled: disabled,
        onSubmit: this.handleSubmit
      }, rest)))));
    };

    return WizardForm;
  }(PureComponent);

  WizardForm.propTypes = process.env.NODE_ENV !== "production" ? {
    // Redux Form
    onSubmit: PropTypes.func.isRequired,
    destroy: PropTypes.func.isRequired,
    // Handler Refs
    backHandlerRef: PropTypes.func,
    // Handlers
    onPageChange: PropTypes.func,
    // Modifiers
    transitionName: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool
  } : {};
  WizardForm.defaultProps = {
    // Handler Refs
    backHandlerRef: null,
    // Handlers
    onPageChange: null,
    // Modifiers
    transitionName: 'carousel',
    className: '',
    disabled: false
  };
  return {
    Form: connect(null, {
      destroy: function destroy() {
        return _destroy2(formName);
      }
    })(WizardForm),
    isInvalid: isInvalid(formName),
    submit: function submit() {
      return _submit(formName);
    }
  };
}